module.exports = __webpack_public_path__ + "static/screenshot-d6f6bfd84b75c1c1643d8418069fe11b.png";